//const { useEffect, useState } = wp.element;
//import React, {useState, useEffect} from "react";

export const IconListRenderer = ({
    items = [],
    variant = '',
    linkStyle = 'all',
    hasText = true,
    hasTitles = false,
    hasLinks = false,
    hlevel = 4,
    itemColor,
    iconSize,
    children = null,
}) => {
    const renderTitle = (title, hlevel) => {
        switch (hlevel) {
            case 1: return <h1 className="list-title">{title}</h1>;
            case 2: return <h2 className="list-title">{title}</h2>;
            case 3: return <h3 className="list-title">{title}</h3>;
            case 4: return <h4 className="list-title">{title}</h4>;
            case 5: return <h5 className="list-title">{title}</h5>;
            case 6: return <h6 className="list-title">{title}</h6>;
            default: return <h4 className="list-title">{title}</h4>;
        }
    };

    const IconWrapper = ({ item }) => {
        if (item.svgContent) {
            return <div className="iconwrap" dangerouslySetInnerHTML={{ __html: item.svgContent }} />;
        }
        if (item.icon.mediaUrl) {
            return <div className="iconwrap"><img src={item.icon.mediaUrl} alt={item.title} /></div>;
        }
        return null;
    };

    const renderContentWithLinks = (item, hasTitles, hasText, linkStyle, hlevel) => {
        switch (linkStyle) {
            case 'all':
                return (renderContentNoLinks(item, hasTitles, hasText, hlevel));
            case 'icon':
                return (
                    <div className="wrap">
                        <a href={item.link}>
                            <IconWrapper item={item} />
                        </a>
                        {hasTitles && renderTitle(item.title, hlevel)}
                        {hasText && (
                            <div className="body">
                                <p className="list-text" dangerouslySetInnerHTML={{ __html: item.text }} />
                            </div>

                        )}
                    </div>
                );
            case 'title':
                return (
                    <div className="wrap">
                        <IconWrapper item={item} />
                        {hasTitles &&
                            <a href={item.link}>
                                {renderTitle(item.title, hlevel)}
                            </a>
                        }
                        {hasText && (
                            <div className="body">
                                <p className="list-text" dangerouslySetInnerHTML={{ __html: item.text }} />
                            </div>

                        )}
                    </div>
                );
            //case 'content':
            default:
                return (
                    <div className="wrap">
                        <IconWrapper item={item} />
                        <a href={item.link}>
                            {hasTitles && renderTitle(item.title, hlevel)}
                            {hasText && (
                                <div className="body">
                                    <p className="list-text" dangerouslySetInnerHTML={{ __html: item.text }} />
                                </div>

                            )}
                        </a>
                    </div>
                );
        }
    };

    const renderContentNoLinks = (item, hasTitles, hasText, hlevel) => {
        if (!item?.icon?.mediaUrl) return null;
        return (
            <div className="wrap">
                <IconWrapper item={item} />
                <div className="textwrap">
                    {hasTitles && renderTitle(item.title, hlevel)}
                    {hasText && (
                        <div className="body">
                            <p className="list-text" dangerouslySetInnerHTML={{ __html: item.text }} />
                        </div>

                    )}
                </div>
            </div>
        );
    };

    const renderAccordionItem = (item, hasText, hasTitles) => {
        if (!hasText || !hasTitles) return null;
        return (
            <li className="accordion-wrap" style={{ color: "inherit" }}>
                <div className="image-wrap">
                    <IconWrapper item={item} />
                </div>
                <div class="textwrap">
                    <h4
                        className="accordion-title"
                        onclick="accordionClick(event)"
                        style={{ display: "flex", gap: "20px", alignItems: "center", color: "inherit" }}
                    >
                        <span>{item.title}</span>
                        <span className="accordion-plus">
                            <svg className="plus-icon" width="22" height="22" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                <path className="y-axis" d="M50 20 V80" stroke="currentColor" strokeWidth="10" strokeLinecap="round" />
                                <path className="x-axis" d="M20 50 H80" stroke="currentColor" strokeWidth="10" strokeLinecap="round" />
                            </svg>
                        </span>
                    </h4>
                    <div className="accordion-panel">{item.text}</div>
                </div>
            </li>
        );
    };

    const renderContent = (item, hasTitles, hasText, hasLinks, linkStyle, hlevel) => {
        if (variant === 'accordion') {
            return renderAccordionItem(item, hasText, hasTitles);
        }
        return hasLinks ? renderContentWithLinks(item, hasTitles, hasText, linkStyle, hlevel)
            : renderContentNoLinks(item, hasTitles, hasText, hlevel);
    };

    const renderGridItem = (item, index, linkStyle, hasText, hasTitles, hasLinks, hlevel, itemColor) => {
        const content = renderContent(item, hasTitles, hasText, hasLinks, linkStyle, hlevel);
        return (
            <div key={index} className="grid-item" style={{ color: itemColor }}>
                {hasLinks && item.link && linkStyle === 'all' ? (
                    <a href={item.link}>{content}</a>
                ) : content}
            </div>
        );
    };

    const renderListItem = (item, index, linkStyle, hasText, hasTitles, hasLinks, hlevel, itemColor, itemSize) => {
        const content = renderContent(item, hasTitles, hasText, hasLinks, linkStyle, hlevel);
        itemSize = itemSize ? itemSize : "48px";
        itemColor = itemColor ? itemColor : "inherit";
        return (
            <li key={index} className="list-item" style={{ color: itemColor, '--icon-size': itemSize }}>
                {hasLinks && item.link && linkStyle === 'all' ? (
                    <a href={item.link}>{content}</a>
                ) : content}
            </li>
        );
    };

    const renderGrid = (items, linkStyle, hasText, hasTitles, hasLinks, hlevel, itemColor) => (
        <div className="list-icon-grid">
            {items.map((item, index) => renderGridItem(item, index, linkStyle, hasText, hasTitles, hasLinks, hlevel, itemColor))}
        </div>
    );

    const renderList = (items, variant, linkStyle, hasText, hasTitles, hasLinks, hlevel, itemColor, itemSize) => (
        <ul className={`list-icon ${variant}`} >
            {items.map((item, index) => renderListItem(item, index, linkStyle, hasText, hasTitles, hasLinks, hlevel, itemColor, itemSize))}
        </ul>
    );

    const renderAccordion = (items) => (
        <ul className="accordion-list">
            {items.map((item, index) => renderAccordionItem(item, hasText, hasTitles, hlevel))}
        </ul>
    );

    if (variant === 'accordion') {
        return renderAccordion(items);
    }
    return variant === 'grid'
        ? renderGrid(items, linkStyle, hasText, hasTitles, hasLinks, hlevel, itemColor)
        : renderList(items, variant, linkStyle, hasText, hasTitles, hasLinks, hlevel, itemColor, iconSize);
};